(function($){
  $(function(){
    $window = $(window);

    // build accordions
    var $accordions = $('ul.accordion');
    if ($accordions.length) {
      $accordions.each(function(idx,itm) {
        var idxClass = "accordion" + idx,
            curAcc = $(itm);

        curAcc.addClass(idxClass).children('li').each(function(idx2,listItem) {
          var curItem = $(listItem);
          curItem.children('.title').on('click',function() {
            curItem.toggleClass(actClass).find('.content').slideToggle('fast', function() {
              $window.trigger('resize');
            });
          });
        });   

        if(curAcc.hasClass('controls')) {
          $('<div class="accordion-controls accordion'+idx+'"><a href="#" class="expand-all">Expand All</a><a href="#" class="collapse-all">Collapse All</a></div>').insertBefore(curAcc);

          var thisModes = '.accordion-controls.accordion' + idx;

          $(thisModes).children('a').on('click',function(e) {
              e.preventDefault();

              if($(this).hasClass('expand-all')) { curAcc.children('li').addClass(actClass).find('.content').slideDown('fast', function() { $window.trigger('resize'); }) }
              if($(this).hasClass('collapse-all')) { curAcc.children('li').removeClass(actClass).find('.content').slideUp('fast', function() { $window.trigger('resize'); }) }
          });
        }
      });
      
      // accessibility support
      $accordions.find('li > .title').addAccess();
    }

    // build rich text accordions
    var $rtaccordions = $('.rt-accordion');
    if ($rtaccordions.length) {
        $rtaccordions.each(function (i, item) {
            var $acc = $(item);
            $acc.find('.hide').hide().removeClass('hide'); // take of hide class            

            $acc.find('.rta-control').on('click', function (e) {
                e.preventDefault();

                if ($(this).hasClass('expand-all')) { $acc.find('.rta-content').slideDown('fast', function () { $window.trigger('resize'); }) }
                else if ($(this).hasClass('collapse-all')) { $acc.find('.rta-content').slideUp('fast', function () { $window.trigger('resize'); }) }
                $acc.find('.rta-control').show();
                $(this).hide();                
            });
        });
    }

  });  
})($JQ);